import { DAYS_PER_WEEK, parseIso, shiftDays, shiftMonths, weekdayIndex } from './calendarGrid';

/**
 * What a key press means for a day cell. `null` is "not ours" — the component
 * must then leave the event alone, or it would swallow Tab and the host app's
 * own shortcuts.
 */
export type DayKeyAction = { kind: 'select' } | { kind: 'move'; date: string } | null;

/** Arrow keys walk the raster: one day sideways, one whole week vertically. */
const STEP_DAYS: Record<string, number> = {
  ArrowRight: 1,
  ArrowLeft: -1,
  ArrowDown: DAYS_PER_WEEK,
  ArrowUp: -DAYS_PER_WEEK,
};

/**
 * Resolves a key press against a date, without a grid and without a DOM: the
 * row a date sits in IS its calendar week, so Home and End are week arithmetic
 * rather than a lookup in the rendered cells. That also makes them right for a
 * date the current block only shows as a filler.
 */
export function dayKeyAction(key: string, iso: string, firstDayOfWeek: 1 | 7): DayKeyAction {
  if (key === 'Enter' || key === ' ') return { kind: 'select' };

  const step = STEP_DAYS[key];
  if (step !== undefined) return { kind: 'move', date: shiftDays(iso, step) };

  if (key === 'Home' || key === 'End') {
    const { year, month, day } = parseIso(iso);
    const index = weekdayIndex(new Date(year, month - 1, day), firstDayOfWeek);
    const offset = key === 'Home' ? -index : DAYS_PER_WEEK - 1 - index;
    return { kind: 'move', date: shiftDays(iso, offset) };
  }

  if (key === 'PageUp' || key === 'PageDown') {
    return { kind: 'move', date: shiftMonths(iso, key === 'PageDown' ? 1 : -1) };
  }

  return null;
}
